import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const DescriptionBox = styled.div`
	display: flex;	
	margin-bottom: 12px;	
	i {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 65px;
		height: 65px;
		border-radius: 100%;
		color: white;
		margin-left: 35px;
		background-color: ${(props) => props.color};
		font-size: 1.5rem;
		
		&:before {
			margin: 0;
		}
	}
`;
export const DescriptionContent = styled.div`
	max-width: 460px;
	strong {		
		font-size: 20px;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.55;		
		color: ${Variables.colors.complementary_800};
	}
	p {
		margin: 0;
		font-size: 14px;
		font-weight: 300;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.57;		
		color: ${Variables.colors.complementary_700};
	}
`;